import { ArrowUpRight, Phone, Mail, MapPin } from "lucide-react";
import { PageHead } from "@/components/site/PageHead";
import { FadeUp } from "@/components/site/Reveal";
import { CONTACT } from "@/data/products";

const CARDS = [
  { icon: Phone, label: "Call", value: CONTACT.phone, href: `tel:${CONTACT.tel}`, id: "contact-phone", bg: "bg-[#0B0B0B] text-white" },
  { icon: Phone, label: "Call (2nd line)", value: CONTACT.phone2, href: `tel:${CONTACT.tel2}`, id: "contact-phone2", bg: "bg-[#1C1C1C] text-white" },
  { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}`, id: "contact-email", bg: "bg-[#FF5A00] text-[#0B0B0B]" },
  { icon: MapPin, label: "Factory", value: CONTACT.address, href: null, id: "contact-address", bg: "bg-[#FFC400] text-[#0B0B0B]" },
];

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHead eyebrow="Contact · MOQ 100 kg" lines={["Call us.", <span key="e" className="text-[#FF5A00]">Or write.</span>]}>
        <p className="mt-8 max-w-xl text-base text-zinc-700 md:text-lg">Tell us your substrate, printing process and quantity — we'll recommend the right ink.</p>
      </PageHead>
      <section className="mx-auto grid max-w-[1440px] gap-4 px-5 pb-28 sm:grid-cols-2 lg:grid-cols-4 md:px-10">
        {CARDS.map(({ icon: Icon, label, value, href, id, bg }, i) => {
          const inner = (
            <>
              <div className="flex items-start justify-between">
                <Icon className="h-7 w-7" />
                {href && <ArrowUpRight className="h-7 w-7 transition-transform duration-500 group-hover:rotate-45" />}
              </div>
              <div>
                <p className="font-mono text-xs uppercase tracking-[0.2em] opacity-80">{label}</p>
                <p className="font-wide mt-3 break-words text-xl font-bold leading-tight md:text-2xl lg:text-xl">{value}</p>
              </div>
            </>
          );
          const cls = `group flex min-h-[280px] flex-col justify-between p-8 transition-transform duration-500 hover:-translate-y-1 ${bg}`;
          return (
            <FadeUp key={id} delay={i * 0.1}>
              {href ? <a href={href} data-testid={id} className={cls}>{inner}</a> : <div data-testid={id} className={cls}>{inner}</div>}
            </FadeUp>
          );
        })}
      </section>
    </div>
  );
}
